import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const Svg7 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 1C24.2843 1 31 7.71573 31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1Z M16.5807 25H12.7887L18.4047 11.176H13.1727V14.224H10.1247V8.248H21.9807V11.368L16.5807 25Z",
		fill: "currentColor"
	})
});
export default Svg7;
